import { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from '../../routes/routeConstants/apiRoutes';
import { deserialize } from 'serializr';
import { SbtiResponse } from 'models/Sbti/sbti.model';
import { generatePath } from 'react-router-dom';
import { handleBlobDownload } from 'shared/utils/handleBlobDownload';
import { DownloadKeys } from 'enums/GraphDropdownEnums';

const SbtiService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [sbtiTargets, setSbtiTargets] = useState<SbtiResponse | undefined>(
    undefined
  );

  const fetchSbtiTargets = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.TARGET);
      const deserializedData = deserialize(SbtiResponse, response.data);
      setSbtiTargets(deserializedData);
    } catch (error) {
      setSbtiTargets({});
    } finally {
      setLoading(false);
    }
  };
  const downloadSbtiCsv = async (id: number) => {
    const params = {
      export_type: DownloadKeys.CSV,
    };
    const url = generatePath(ApiRoutes.DWLD_SBTI_CSV, { sbtiTargetId: id });
    try {
      const response = await axiosInstance.get(url, { params });
      handleBlobDownload(response);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchSbtiTargets,
    downloadSbtiCsv,
    sbtiTargets,
  };
};

export default SbtiService;
